import * as actions from './actionTypes';


export function logIn(currentUser) {
    return {
        type: actions.LOGGED_IN,
        payload: {
            currentUser: currentUser
        }
    }
}
export function logOut() {
    return {
        type: actions.LOGGED_OUT,
        payload: {
            
        }
    }
}
export function fetchFeedPosts(feedPosts) {
    return {
        type: actions.FETCH_FEED_POSTS,
        payload: {
            feedPosts: feedPosts
        }
    }
}
export function fetchCurrentUserPosts(currentUserPosts) {
    return {
        type: actions.FETCH_USER_POSTS,
        payload: {
            currentUserPosts: currentUserPosts
        }
    }
}
export function fetchProfileViewPosts(postObject) {
    return {
        type: actions.FETCH_PROFILE_VIEW_POSTS,
        payload: {
            postObject: postObject
        }
    }
}
export function likePost(postObject) {
    return {
        type: actions.LIKE_POST,
        payload: {
            postObject: postObject
        }
    }
}
export function savePost(postObject) {
    return {
        type: actions.SAVE_POST,
        payload: {
            postObject: postObject
        }
    }
}
export function unlikePost(postObject) {
    return {
        type: actions.UNLIKE_POST,
        payload: {
            postObject: postObject
        }
    }
}
export function unsavePost(postObject) {
    return {
        type: actions.UNSAVE_POST,
        payload: {
            postObject: postObject
        }
    }
}
export function fetchAllUsers(allUsers) {
    return {
        type: actions.FETCH_ALL_USERS,
        payload: {
            allUsers: allUsers
        }
    }
}